import { FontIcon, Stack } from "@fluentui/react";
import { IStandardColumn } from "../models/StandardColumn";
import { addSortLabels } from "./utils";

export type BulkApproverPreviewRow = {
    id: string;
    name: string;
    sourceFoundInFirstStage: boolean;
    sourceFoundInSecondStage: boolean;
    operationResult?: string;
};

export type BulkApproverSkippedRow = {
    id: string;
    name: string;
    skipReason: string;
};

export function generateBulkApproverPreviewColumns(includeOperationResult = false): IStandardColumn[] {
    const columns: IStandardColumn[] = [
        {
            key: "name",
            name: "Name",
            fieldName: "name",
            filterBy: true,
            minWidth: 120,
            maxWidth: 300,
            isResizable: true,
            isSorted: true,
            onRender: (item: BulkApproverPreviewRow) => (
                <Stack tokens={{ childrenGap: 10 }} horizontal>
                    <Stack.Item>
                        <FontIcon iconName="ELM" />
                    </Stack.Item>
                    <Stack.Item align="center">{item.name}</Stack.Item>
                </Stack>
            )
        },
        {
            key: "sourceFoundInFirstStage",
            name: "Matched In First Stage",
            fieldName: "sourceFoundInFirstStage",
            minWidth: 100,
            maxWidth: 180,
            isResizable: true,
            onRender: (item: BulkApproverPreviewRow) => (item.sourceFoundInFirstStage ? "Yes" : "No")
        },
        {
            key: "sourceFoundInSecondStage",
            name: "Matched In Second Stage",
            fieldName: "sourceFoundInSecondStage",
            minWidth: 100,
            maxWidth: 180,
            isResizable: true,
            onRender: (item: BulkApproverPreviewRow) => (item.sourceFoundInSecondStage ? "Yes" : "No")
        }
    ];

    if (includeOperationResult) {
        columns.push({
            key: "operationResult",
            name: "Operation Result",
            fieldName: "operationResult",
            minWidth: 130,
            maxWidth: 220,
            isResizable: true,
            onRender: (item: BulkApproverPreviewRow) => item.operationResult || "Not attempted"
        });
    }

    addSortLabels(columns);
    return columns;
}

export function generateBulkApproverSkippedColumns(): IStandardColumn[] {
    const columns: IStandardColumn[] = [
        {
            key: "name",
            name: "Name",
            fieldName: "name",
            filterBy: true,
            minWidth: 120,
            maxWidth: 300,
            isResizable: true,
            isSorted: true,
            onRender: (item: BulkApproverSkippedRow) => (
                <Stack tokens={{ childrenGap: 10 }} horizontal>
                    <Stack.Item>
                        <FontIcon iconName="ELM" />
                    </Stack.Item>
                    <Stack.Item align="center">{item.name}</Stack.Item>
                </Stack>
            )
        },
        {
            key: "skipReason",
            name: "Skip Reason",
            fieldName: "skipReason",
            minWidth: 200,
            maxWidth: 500,
            isResizable: true,
            onRender: (item: BulkApproverSkippedRow) => item.skipReason
        }
    ];

    addSortLabels(columns);
    return columns;
}
